<template>
  <section class="default-layout">
    <AppHeader />
    <section
      class="intensive"
      v-if="
        getIntensiveDetail &&
        Object.keys(getIntensiveDetail).length &&
        getIntensiveDetail.translates.length
      "
    >
      <TopBanner class="mb-16" :item="banner" />
      <div class="_mt-16">
        <div class="container _py-16 _px-sm-0 _py-md-12">
          <div class="intensive__info">
            <Speakers
              :speakers="getIntensiveDetail.speakers"
              v-if="
                getIntensiveDetail.speakers &&
                getIntensiveDetail.speakers.length
              "
            />
            <div class="intensive__progress _py-10 _pa-sm-8 _px-8">
              <div class="speakers__title _fs-24 _lh-32 _tc-dark-grey _mb-8">
                {{ $t("pages.intensive_detail.progress.title") }}
                <span
                  class="d-block _mt-2 _fs-16 _lh-24 intensive-progress__title"
                  v-html="currentTranslate.title"
                ></span>
              </div>
              <div class="progress__item _mb-8" v-if="videoCount">
                <Progress
                  :value="videoCompleted"
                  :total="videoCount"
                  class="_mr-4"
                >
                  <template v-slot:progress="props">
                    <span class="_fs-20 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-20 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _tc-dark _mb-1"
                  >
                    {{ $t("pages.intensive_detail.progress.trainings") }}
                  </div>
                  <div class="progress__description _fs-16 _tc-dark-grey">
                    {{ $t("pages.intensive_detail.progress.complete") }}
                  </div>
                </div>
              </div>
              <div class="progress__item _mb-8" v-if="testCount">
                <Progress
                  :value="testCompleted"
                  :total="testCount"
                  class="_mr-4"
                >
                  <template v-slot:progress="props">
                    <span class="_fs-20 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-20 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _tc-dark _mb-1"
                  >
                    {{ $t("pages.intensive_detail.progress.test") }}
                  </div>
                  <div class="progress__description _fs-16 _tc-dark-grey">
                    {{ $t("pages.intensive_detail.progress.complete") }}
                  </div>
                </div>
              </div>
              <div class="progress__item mb-8">
                <Progress :value="certificateIsGet" :total="1" class="_mr-4">
                  <template v-slot:progress="props">
                    <span class="_fs-20 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-20 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _tc-dark _mb-1"
                  >
                    {{ $t("pages.intensive_detail.progress.cert") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="intensive__tabs _mt-16"
            v-if="getScreencastsList && getScreencastsList.length"
          >
            <div
              :class="{ 'router-link-active': $route.name === 'Intensive' }"
              @click="
                tabClick(
                  'intensive_tab_tolesson',
                  helpers.buildRoute({ name: 'Intensive' })
                )
              "
              class="intensive__tab _py-4 _py-sm-2 _px-5"
            >
              {{ $t("pages.intensive_detail.sections.lessons") }}
            </div>
            <div
              :class="{ 'router-link-active': $route.name === 'Screencast' }"
              @click="
                tabClick(
                  'intensive_tab_toscreencast',
                  helpers.buildRoute({ name: 'Screencast' })
                )
              "
              class="intensive__tab _py-4 _py-sm-2 _px-5"
            >
              {{ $t("pages.intensive_detail.sections.screencasts") }}
            </div>
          </div>
        </div>
      </div>
      <main>
        <router-view />
      </main>
      <div class="intensive__info-bottom _pt-16">
        <div class="container _px-md-4">
          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _fw-600">
            {{ $t("pages.intensive_detail.total_progress") }}
          </h2>
          <div class="intensive__info-row _mb-16">
            <div
              class="intensive__progress _py-10 _px-8"
              v-for="(item, ind) in getIntensiveTotalProgress"
              :key="ind"
            >
              <div class="progress__item">
                <Progress
                  :value="Math.round(item.progress_percent)"
                  :total="100"
                  class="_mr-4"
                >
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-1"
                    v-html="
                      getProgressTranslate(item, Trans.currentLocale).title
                    "
                  ></div>
                  <AppBtn
                    @click.native="showCertModal(true, certData)"
                    :disabled="Math.round(item.progress_percent) !== 100"
                    class="_py-2 _px-4 _mt-2"
                    :btnClass="'btn_secondary'"
                  >
                    <span class="_fs-16 _fw-500">{{
                      $t("pages.intensive_detail.download_cert")
                    }}</span>
                  </AppBtn>
                </div>
              </div>
            </div>
          </div>
          <div
            class="intensive__certificate certificate _mb-16 _px-md-6 _py-md-8 _px-16 _py-8"
          >
            <picture>
              <source
                :srcset="
                  require('@/assets/img/blocks/intensives/intensive-cert-375.jpg')
                "
                media="(max-width: 743px)"
              />
              <source
                :srcset="
                  require('@/assets/img/blocks/intensives/intensive-cert-768.jpg')
                "
                media="(max-width: 1220px)"
              />
              <source
                :srcset="
                  require('@/assets/img/blocks/intensives/intensive-cert-1920.jpg')
                "
                media="(min-width: 1280px)"
              />
              <img
                class="certificate__img"
                :src="
                  require('@/assets/img/blocks/intensives/intensive-cert-1920.jpg')
                "
              />
            </picture>
            <div
              class="certificate__caption _mr-8 _mr-md-0 _mb-md-4 _fs-24 _fs-sm-20 _lh-sm-24 _lh-32 tc-dark _fw-600"
            >
              {{ $t("pages.intensive_detail.cert.title") }}
              <span v-html="currentTranslate.title"></span>
            </div>
            <div class="certificate__description">
              <span class="_fs-16 _lh-24 _tc-dark-grey">{{
                $t("pages.intensive_detail.cert.description")
              }}</span>
              <AppBtn
                @click.native="showCertModal(true, certData)"
                :btnClass="'btn_orange'"
                :disabled="!certAccess"
                class="_mt-4"
                ><span class="_tc-white _fs-18 _py-2 _px-3">{{
                  $t("pages.intensive_detail.download_cert")
                }}</span></AppBtn
              >
            </div>
          </div>
        </div>
        <div class="_bg-light">
          <OtherMain :items="sectionsList" :analyticEventPrefix="'intensive_'">
            <template v-slot:title>
              <div
                class="section-detail__title _fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _fw-600"
              >
                {{ $t("another_sections_title") }}
              </div>
            </template>
          </OtherMain>
        </div>
      </div>
    </section>
    <ErrorPage
      v-if="
        getIntensiveDetail !== 404 &&
        getIntensiveDetail !== null &&
        typeof getIntensiveDetail !== 'object'
      "
      :code="`${getIntensiveDetail}`"
    />
    <Choch v-else-if="getIntensiveDetail === 404" />
    <AppFooter />
  </section>
</template>

<script>
import Choch from "@/views/404";
import AppHeader from "@/layouts/components/AppHeader";
import AppFooter from "@/layouts/components/AppFooter";
import TopBanner from "@/components/UI/banners/TopBanner.vue";
import Speakers from "../components/UI/intensives/Speakers.vue";
import Progress from "../components/UI/intensives/Progress.vue";
import AppBtn from "../components/UI/buttons/AppBtn.vue";
import validate from "@/mixins/validate";
import OtherMain from "@/components/UI/OtherMain";
import { bus } from "@/main";

import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo() {
    if (
      this.getIntensiveDetail &&
      Object.keys(this.getIntensiveDetail).length &&
      this.getIntensiveDetail.translates.length
    ) {
      return { title: this.getIntensiveDetail.translates[0].title };
    } else {
      return { title: this.$t("interface.menu.intensives") };
    }
  },
  name: "IntensiveLayout",
  components: {
    Choch,
    AppHeader,
    AppFooter,
    TopBanner,
    Speakers,
    Progress,
    AppBtn,
    OtherMain,
  },
  mixins: [validate],
  data: () => ({
    certModal: false,
    certName: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
  }),
  computed: {
    ...mapGetters([
      "getIntensiveDetail",
      "getIntensiveTotalProgress",
      "getScreencastsList",
      "user",
    ]),
    certData() {
      return {
        name: this.currentTranslate.title.replace(/[<]br[^>]*[>]/gi, " "),
        slug: this.getIntensiveDetail.slug,
        color: this.colorScheme[this.getIntensiveDetail.slug],
      };
    },
    certificateIsGet() {
      return this.user.certificates.includes(this.getIntensiveDetail.slug)
        ? 1
        : 0;
    },
    colorScheme() {
      return {
        "social-media-intensive": "green",
        "online-community-intensive": "green",
        "new-realities": "green",
      };
    },
    sectionsList() {
      const vm = this;
      return this.$t("another_sections") &&
        Array.isArray(this.$t("another_sections"))
        ? this.$t("another_sections")
            .filter((el) => !el.hide)
            .map(function (el) {
              return {
                ...el,
                image: require(`@/assets/img/sections/${el.image}`),
                route: vm.helpers.buildRoute(el.route),
              };
            })
        : null;
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    currentTranslate() {
      return this.getIntensiveDetail.translates[0];
    },
    testCount() {
      return this.getIntensiveDetail.lessons.filter(
        (el) => el.translates && el.translates.length && el.tests.length
      ).length;
    },
    testCompleted() {
      return this.getIntensiveDetail.lessons.filter(
        (el) =>
          el.translates &&
          el.translates.length &&
          el.tests.length &&
          !el.tests.filter((test) => test.view === false).length
      ).length;
    },
    videoCount() {
      return this.getIntensiveDetail.lessons.filter(
        (el) => el.translates && el.translates.length && el.translates[0].video
      ).length;
    },
    videoCompleted() {
      return this.getIntensiveDetail.lessons.filter(
        (el) => el.translates && el.translates.length && el.view
      ).length;
    },
    certAccess() {
      return (
        this.videoCount === this.videoCompleted &&
        this.testCount === this.testCompleted
      );
    },
    banner() {
      return {
        title: this.currentTranslate.title,
        descr: this.currentTranslate.description,
        theme: "dark",
        images: this.currentTranslate?.banners
          .map((el) => ({
            src: el.file || el.link,
            media: el.media,
          }))
          .sort(function (a, b) {
            if (parseInt(a.media) > parseInt(b.media)) {
              return 1;
            }
            if (parseInt(a.media) < parseInt(b.media)) {
              return -1;
            }
            return 0;
          }),
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchIntensiveDetail",
      "IntensivesTotalProgress",
      "fetchScreencastsList",
    ]),
    tabClick(event, path) {
      this.$router.push(path);
      if (this.$gtm) {
        this.$gtm.push({
          event: event,
        });
      }

      // Функция для периодической проверки наличия блока
      const scrollToTabsBlock = () => {
        const tabsBlock = document.querySelector(".intensive__tabs");
        if (tabsBlock) {
          tabsBlock.scrollIntoView({ behavior: "smooth" });
          clearInterval(checkExist);
        }
      };

      // Периодическая проверка элемента в DOM
      const checkExist = setInterval(() => {
        scrollToTabsBlock();
      }, 10); // Проверка каждые 100 мс

      // Остановим проверку через 3 секунды, если элемент не найден
      setTimeout(() => {
        clearInterval(checkExist);
      }, 3000);
    },
    getTranslate(item) {
      return item.translates[0];
    },
    getProgressTranslate(item, lang) {
      return (
        item.translates.find((el) => el.language === lang) ||
        item.translates.find((el) => el.language === "ru")
      );
    },
    showCertModal(state, intensive) {
      bus.$emit("showCertModal", state, intensive);
      if (this.$gtm) {
        this.$gtm.push({
          event: "intensive_sertificat",
          param_value: this.helpers.stripHtml(intensive.name),
        });
      }
    },
  },
  async mounted() {
    if (this.$route.params && this.$route.params.slug) {
      await this.fetchIntensiveDetail({
        lang: this.currentLocale,
        slug: this.$route.params.slug,
      });
      if (this.getScreencastsList && !this.getScreencastsList.length) {
        await this.fetchScreencastsList({
          lang: this.Trans.currentLocale,
          intensive_slug: this.$route.params.slug,
          category_name: this.currentCategory,
        });
      }
    }
    await this.IntensivesTotalProgress();
  },
};
</script>

<style lang="scss" scoped>
.default-layout {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr min-content;
}

.intensive {
  &__info {
    display: grid;
    grid-template-columns: 1fr 384px;
    column-gap: 32px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 32px;
    }
  }

  &__progress {
    border: 1px solid color("grey-second");
    border-radius: 16px;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__tab {
    text-decoration: none;
    border-radius: 12px;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    color: color("dark-grey");
    cursor: pointer;

    @media screen and (max-width: 743px) {
      font-size: 24px;
    }
  }

  &__tab.router-link-active {
    background-color: #ebf6e3;
    color: color("green-second");
  }

  &__info-row {
    display: grid;
    grid-template-columns: repeat(3, 384px);
    gap: 32px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 32px;
    }
  }
}

.progress {
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}

.certificate {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 190px;
  position: relative;
  border-radius: 16px;
  border: 1px solid color(grey-second);
  overflow: hidden;

  @media screen and (max-width: 1220px) {
    height: auto;
    flex-direction: column;
    padding-bottom: 380px !important;
  }

  @media screen and (max-width: 743px) {
    height: auto;
    flex-direction: column;
    padding-bottom: 200px !important;
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: bottom right;

    @media screen and (max-width: 1220px) {
      object-position: bottom center;
    }
  }

  &__caption {
    position: relative;
    z-index: 2;
    max-width: 320px;

    @media screen and (max-width: 1220px) {
      max-width: none;
    }
  }

  &__description {
    position: relative;
    z-index: 2;
    max-width: 531px;
    @media screen and (max-width: 1220px) {
      max-width: none;
    }
  }
}
</style>
<style>
.intensive-progress__title br {
  display: none;
}
</style>
